import { useAPI } from "../../../network/SWR";

export function useGetClientList(
  {
    currentPage = 1,
    perPageCount = 10,
    searchQuery = "",
    list = "",
    pagination = false,
  },
  config = {}
) {
  const role = JSON.parse(localStorage.getItem("current_user_details"))?.user
    ?.role?.name;

  // Construct the key based on pagination, search query, and list type
  const key =
    role === "accessionist" || role === "admin"
      ? `/clients?page=${currentPage}&pagination=${pagination}&per_page_count=${perPageCount}&search_key=${searchQuery}&list=${list}`
      : null;

  // Call the API with the constructed key
  const { data, error, loading, mutate, isValidating } = useAPI(key, config, {
    revalidateOnFocus: false,
  });

  return {
    clients: data?.clients,
    pageInfo: data?.page_info ?? {
      total_count: 0,
      current_page: 0,
      per_page: perPageCount,
    },
    error,
    loading,
    mutate,
    isValidating,
  };
}

export function useClientPhysicianList(
  { currentPage = 1, perPageCount = 10, searchQuery = "", list = "" },
  config = {}
) {
  const key = `/clients/physicians.json?page=${currentPage}&per_page_count=${perPageCount}&search_key=${searchQuery}&list=${list}`;
  const { data, error, loading, mutate, isValidating } = useAPI(
    key,
    (config = {})
  );

  return {
    users: data?.physicians ?? [],
    pageInfo: data?.page_info ?? {
      total_count: 0,
      current_page: 0,
      per_page: 10,
    },
    error,
    loading,
    mutate,
    isValidating,
  };
}

export function useSingleClient({ id = null }, config = {}) {
  const key = id !== null ? `/clients/${id}.json` : null;
  const { data, error, loading, mutate, isValidating } = useAPI(
    key,
    (config = {})
  );

  return {
    data: data?.client || {},
    error,
    loading,
    mutate,
    isValidating,
  };
}
